import { required, email, maxLength, minLength } from "vuelidate/lib/validators";

export const restoreValidationForm = {
    email: {required, email, minLength: minLength(1), maxLength: maxLength(255)}
};